/**
 * Fleet panel ids retained for legacy `/fleet/observer?panel=...` links.
 * Each id now resolves to a native Equa page through fleet-navigation.ts.
 */

/** Legacy observer panel ids now mapped to native Equa pages. */
export type FleetNativePanelId =
  | 'agents'
  | 'pipelines'
  | 'threads'
  | 'cursor'
  | 'fleet'
  | 'comet'
  | 'command-center'

export interface FleetNativePanel {
  id: FleetNativePanelId
  label: string
}

export const FLEET_NATIVE_PANELS: FleetNativePanel[] = [
  { id: 'agents', label: 'Agents' },
  { id: 'pipelines', label: 'Pipelines' },
  { id: 'threads', label: 'Task Threads' },
  { id: 'cursor', label: 'Cursor Terminals' },
  { id: 'fleet', label: 'Fleet Log' },
  { id: 'comet', label: 'Comet' },
  { id: 'command-center', label: 'Command Center' },
]

/** @deprecated Use FleetNativePanelId. */
export type FleetIframePanelId = FleetNativePanelId

/** @deprecated Use FleetNativePanel. */
export type FleetIframePanel = FleetNativePanel

/** @deprecated Use FLEET_NATIVE_PANELS. */
export const FLEET_TRACKER_IFRAME_PANELS = FLEET_NATIVE_PANELS

/** @deprecated Use FleetIframePanelId — kept for older imports */
export type FleetTrackerPanel = FleetIframePanel

/** @deprecated Use FLEET_NATIVE_PANELS */
export const FLEET_TRACKER_PANELS = FLEET_NATIVE_PANELS
